import { createRowId } from '../ids';

import { createCardDraftLabel } from './cards';
import type { WhatsNewCarouselCard, WhatsNewCarouselPayloadBuilderState } from './types';

export function createDefaultCard(draftLabel = createCardDraftLabel(0)): WhatsNewCarouselCard {
  return {
    draftId: createRowId(),
    draftLabel,
    isActive: true,
    enabledRegions: [],
    startAt: '',
    endAt: '',
    imageId: '',
    imageOptionsFit: '',
    overline: '',
    title: '',
    description: '',
    ctaLabel: '',
    ctaUrl: '',
    optimizelyFeatureFlag: '',
  };
}

export function createDefaultWhatsNewCarouselState(): WhatsNewCarouselPayloadBuilderState {
  return {
    mode: 'whatsNewCarousel',
    cards: [],
  };
}
